import script from "./TUICallKitMini.vue?vue&type=script&setup=true&lang=ts"
export * from "./TUICallKitMini.vue?vue&type=script&setup=true&lang=ts"

import "./TUICallKitMini.vue?vue&type=style&index=0&id=2feb549c&scoped=true&lang=css"

import exportComponent from "/home/gitlab-runner/builds/3Mswgxxg/0/im/im-web/iguopin-chat/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2feb549c"]])

export default __exports__